import { Entries } from '../types/entries.type';

export function toPairs<T>(value: T): Entries<T, keyof T & string> {
  return Object.entries(value) as unknown as Entries<T, keyof T & string>;
}
